export default __webpack_public_path__ + "static/media/active-cases.75894d75.svg";